import React, { useEffect, useRef } from 'react';
import './HowToBuy.css';
import strkLogo from '../assets/strkLogo.png';
import walletIcon from '../assets/walletIcon.png';
import AVNULogo from '../assets/AVNULogo.png';
import braavos from '../assets/braavos.png';
import argent from '../assets/argent.png';
import externalIcon from '../assets/externalIcon.png';
import character from '../assets/starw1.png';

const HowToBuy = () => {
  const stepsRef = useRef([]);
  const titleRef = useRef(null);
  const titleTextRef = useRef(null);
  const characterRef = useRef(null); // Ref for the character

  const addToRefs = (el) => {
    if (el && !stepsRef.current.includes(el)) {
      stepsRef.current.push(el);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('slide-in'); // Add class to slide in
          observer.unobserve(entry.target); // Stop observing once animated
        }
      });
    }, {
      threshold: 0.6 // Adjust threshold as needed
    });

    // Observe title, title text, and character
    if (titleRef.current) {
      observer.observe(titleRef.current);
    }
    if (titleTextRef.current) {
      observer.observe(titleTextRef.current);
    }
    if (characterRef.current) {
      observer.observe(characterRef.current); // Observe character image
    }

    // Observe steps
    stepsRef.current.forEach(step => {
      observer.observe(step);
    });

    return () => {
      // Unobserve title, title text, and character
      if (titleRef.current) {
        observer.unobserve(titleRef.current);
      }
      if (titleTextRef.current) {
        observer.unobserve(titleTextRef.current);
      }
      if (characterRef.current) {
        observer.unobserve(characterRef.current);
      }
      // Unobserve steps
      stepsRef.current.forEach(step => {
        observer.unobserve(step);
      });
    };
  }, []);

  return (
    <div className="how-to-buy" id="howToBuy"> 
      <div className="how-to-buy-title" ref={titleRef}>How to Buy</div>
      <div className="how-to-buy-title-text" ref={titleTextRef}>On Decentralised Exchanges</div>
      <img src={character} alt="Character" className="how-to-buy-character" ref={characterRef} />
      <div className="step" ref={addToRefs}>
        <img src={walletIcon} alt="Wallet Icon" className="step-icon" />
        <div className="step-title-description-container">
          <div className="step-title">1. Create a Wallet</div>
          <div className="step-description">
            Choose a cryptocurrency wallet that supports Starknet. Follow the wallet's setup instructions to create your account securely.
          </div>
          <div className="wallet-logos">
            <a href="https://braavos.app/" className="wallet-logo-link" target="_blank" rel="noopener noreferrer">
              <img src={braavos} alt="Braavos Logo" className="wallet-logo" />
            </a>
            <a href="https://www.argent.xyz/" className="wallet-logo-link" target="_blank" rel="noopener noreferrer">
              <img src={argent} alt="Argent Logo" className="wallet-logo" />
            </a>
          </div>
        </div>
      </div>
      
      <div className="step" ref={addToRefs}>
        <img src={strkLogo} alt="STRK Logo" className="step-icon" />
        <div className="step-title-description-container">
          <div className="step-title">2. Load Your Wallet</div>
          <div className="step-description">
            <div>Once your wallet is set up, load it with STRK or ETH tokens.</div>
            <div>You can purchase them from a crypto <a className='step-description-link' href="https://coinranking.com/coin/e8MSzQnGc+starknettoken-strk/exchanges" target="_blank" rel="noopener noreferrer">exchange</a> then withdraw it to your wallet.</div>
            <div>
              Or bridge them using a <a className='step-description-link' href="https://www.starknet.io/bridges-and-onramps/" target="_blank" rel="noopener noreferrer">bridge</a> that supports Starknet.
            </div>
            <div>
              Or on-ramp to Starknet with those <a className='step-description-link' href="https://www.starknet.io/bridges-and-onramps/" target="_blank" rel="noopener noreferrer">platforms</a>.
            </div>
          </div>
        </div>
      </div>
      
      <a href="https://app.avnu.fi/en?tokenFrom=0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d&tokenTo=0x78d7dfcddb44667153513bd837ff534ef395484f4b6cf28faa25b2c46e063d9"  target="_blank" rel="noopener noreferrer" className="step step-hover-link" ref={addToRefs}>
        <img src={AVNULogo} alt="AVNU Logo" className="step-icon" />
        <div className="step-title-description-container">
          <div className="step-title">
            3. Swap on AVNU
            <img src={externalIcon} className="avnu-external-icon" alt="External Icon" />
          </div>
          <div className="step-description">
            Use the AVNU platform to swap your tokens to ALF.
          </div>
        </div>
      </a>
    </div>
  );
};

export default HowToBuy;
